import Crud from "../helpers/crud";

const crud = new Crud("project");

export default {
  state() {
    return {
      ...crud.state,

      organizationName: "URBO",
    }
  },

  namespaced: true,

  actions: {
    ...crud.actions,

    async fetchObjects(context, query="") {
      if (query === "")
        query += "?"
      query += `organization__name=${context.getters.getOrganizationName}`
      crud.actions.fetchObjects.bind(this)(context, query);
    },

    async initialize({dispatch}) {
      await dispatch("fetchObjects");
    }
  },

  mutations: {
    ...crud.mutations,
  },

  getters: {
    ...crud.getters,

    getOrganizationName(state) {
      return state.organizationName;
    }
  }
}